<template>
  <div class="card" :class="{'scrolled' : scrolled, 'no-margin-top' : noMarginTop}">
    <div v-if="!noTitle" class="card-header d-flex align-items-center justify-content-between">
      <strong v-if="title">{{ title }}</strong>
      <slot name="header"></slot>
    </div>
    <template v-else>
      <template v-if="$slots['header']">
        <slot name="header"></slot>
      </template>
    </template>

    <div v-if="!table" class="card-body flex-grow-1" @scroll="scrollWatch" ref="cardBody" :class="{'mh-100': maxHeight ,'has-overflow' : hasOverflow(),'d-flex flex-column':fullFlex, 'flex-scroll' : flexScroll}">
      <slot/>
    </div>
    <template v-else>
      <slot/>
    </template>

    <div v-if="$slots['footer']" class="card-footer">
        <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',
  data(){
    return {
      scrolled : false
    }
  },
  props: {
    title: { type: String, default: null },
    table: { type: Boolean, default: false },
    noTitle: { type: Boolean, default: false },
    noMarginTop: { type: Boolean, default: false },
    fullFlex: { type: Boolean, default: false },
    maxHeight: { type: Boolean, default: false },
    flexScroll: {type: Boolean, default: false},
  },
  methods : {
    scrollWatch(ev){
      this.scrolled = ev.target.scrollTop > 0;
    },
    hasOverflow(){
      var el = this.$refs.cardBody;
      if(el){
        return el.clientHeight < el.scrollHeight;
      }
    }
  }
}
</script>
<style scoped>
  .table {
    margin-bottom: 0;
  }
  
  .mh-100 {
    max-height: 100%;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Card.vue